/* eslint-disable @typescript-eslint/no-use-before-define */
import { Typography } from '@euler/app/components/typography';
import { SiteIcon } from '@euler/app/flows/task/components/SiteIcon';
import { HStack } from '@euler/components/layout/Stack';
import {
  getDefectiveLevel,
  getDefectiveLevelColor,
} from '@euler/functions/getDefectiveLevel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { DefectiveLevel, InspectionSiteInfo } from '@euler/model';
import { InspectionReportItem } from '@euler/model/report';
import { memo } from 'react';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { ImageStyle } from 'react-native-fast-image';
import { useTheme } from 'styled-components';

export const DashboardSiteItemCell = memo(
  ({
    item,
    site,
    last,
    iconSize,
    style,
    iconStyle,
    labelStyle,
    statusBadgeStyle,
    statusTextStyle,
  }: {
    item: InspectionReportItem;
    site?: InspectionSiteInfo;
    last?: boolean;
    iconSize?: number;
    style?: StyleProp<ViewStyle>;
    iconStyle?: StyleProp<ImageStyle>;
    labelStyle?: StyleProp<TextStyle>;
    statusBadgeStyle?: StyleProp<ViewStyle>;
    statusTextStyle?: StyleProp<TextStyle>;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    iconSize = iconSize ?? rpx(16);
    const icon = site?.iconUrl;
    const type = icon ? (icon.includes('.svg') ? 'svg' : 'image') : undefined;
    const name = item.siteName ?? site?.name;
    if (name == null) return null;
    const defectiveLevel = getDefectiveLevel(
      item.abnormalLevel,
      item.severityLevel,
    );
    const color = getDefectiveLevelColor(theme, defectiveLevel);
    return (
      <HStack
        css={`
          padding-top: ${rpx(8)}px;
          padding-bottom: ${rpx(8)}px;
          border-bottom-width: ${last ? 0 : 1}px;
          border-bottom-color: #f7f7f7;
        `}
        style={style}
      >
        <HStack
          justifyContent="flex-start"
          css={`
            flex: 1;
          `}
        >
          <SiteIcon
            type={type}
            url={icon}
            size={iconSize}
            color={'#888'}
            css={`
              top: ${rpx(1.5)}px;
            `}
            style={iconStyle}
          />
          <Typography.Label
            light
            size={rpx(15)}
            numberOfLines={1}
            css={`
              margin-left: ${rpx(8)}px;
              flex: 1;
            `}
            style={labelStyle}
          >
            {name}
          </Typography.Label>
        </HStack>
        <View
          css={`
            border-color: ${color};
            border-width: 1px;
            height: ${rpx(20)}px;
            border-radius: ${rpx(10)}px;
            padding: 0 ${rpx(10)}px;
            justify-content: center;
            align-items: center;
          `}
          style={statusBadgeStyle}
        >
          <Typography.Label
            color={color}
            size={rpx(12)}
            lineHeight={rpx(18)}
            css={`
              text-align: center;
            `}
            style={statusTextStyle}
          >
            {defectiveLevel === DefectiveLevel.Fine ? '未点亮' : '已点亮'}
          </Typography.Label>
        </View>
      </HStack>
    );
  },
);
